import React from "react";

const InputComponent = ({
  name,
  type,
  placeholder,
  value,
  setValue,
  required,
  maxLength,
  disabled,
  rows,
}) => {
  if (type === "textarea") {
    return (
      <>
        <div className="w-full relative">
          <label
            htmlFor={name}
            className="po block text-sm font-medium capitalize leading-6 text-gray-900 mb-2"
          >
            {name} {required ? <span className="text-red-600 font-bold">*</span> : ""}{" "}
          </label>
          <textarea
            type="textarea"
            id={name}
            className="focus:!border-blue-500 focus:shadow-md w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 transition-all"
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            maxLength={maxLength}
            disabled={disabled}
            rows={rows}
          />
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="w-full">
          <label
            htmlFor={name}
            className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-0"
          >
            {name} {required ? <span className="text-red-600 font-bold">*</span> : ""}{" "}
          </label>
          <input
            type={type}
            id={name}
            className="focus:!border-blue-500 focus:shadow-md focus:bg-white bg-gray-50 border border-blue-500 text-gray-900 text-sm rounded-lg block w-full p-2.5 transition-all"
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            maxLength={maxLength}
            disabled={disabled}
          />
        </div>
      </>
    );
  }
};

export default InputComponent;
